<template>
    <v-col class="pr-0 py-0 mb-0">
        <v-row class="mr-0">
            <v-card
                flat
                :width="width"
                align="center"
                justify="center"
                color="grey lighten-5"
                dark
            >
                <span 
                    class="mr-3 text-subtitle-1 green--text"                                         
                > {{ studentName }}</span>                                 
                <span 
                    class="text-subtitle-1 green--text"
                >{{ classId }}</span>
            </v-card>
        </v-row>

        <v-row class="mr-0">
            <v-card                                    
                :width="width"
                flat
                color="grey lighten-5"                
                dark                                    
            >
                <v-row
                    class="px-3"
                >
                    <v-col
                        align="center"
                        justify="center"
                        v-for="item in academicPeriod"
                        :key="item.title"
                        class="pa-0"
                    >
                        <div 
                            class="text-caption blue--text"
                        >{{item.title}}</div>
                        <div 
                            class="text-caption green--text"
                        >{{item.value}}</div>
                    </v-col>
                </v-row>
            </v-card>                                 
        </v-row>

        <v-row class="mr-0">
            <v-card
                :width="width"
                flat
            >
                <div>
                    <v-list class="py-0" dense>
                        <v-list-item
                            v-for="item in recordSummary"
                            :key="item.title"
                            class="pr-0 mb-2"
                        >
                            <v-list-item-content class="py-0">
                                <v-list-item-title 
                                    class="text-caption"
                                >
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-card                               
                                width="150"                                                                                                       
                                flat
                            >
                                <v-text-field
                                    v-if="!item.select"
                                    :disabled = "item.disabled"
                                    :filled = "item.disabled" 
                                    @blur="updateRecord"
                                    @input="checkNumber(item.model)"
                                    dense
                                    outlined
                                    hide-details
                                    v-model="studentRecord[item.model]"
                                    height="30"
                                    class="text-caption pa-0"
                                    type="number"
                                ></v-text-field>

                                <v-select
                                    v-else-if="item.select"
                                    :disabled = "item.disabled"
                                    :filled = "item.disabled"
                                    :items="grades2"
                                    item-text="grade"
                                    item-value="grade"                                     
                                    v-model="studentRecord[item.model]"
                                    hide-details                                    
                                    outlined
                                    class="text-caption text-center"
                                    @change="updateRecord"
                                    chips
                                    deletable-chips                                    
                                >  
                                    <template v-slot:item="{ item }">
                                        {{ item.grade }} {{ item.description }}    
                                    </template>                                 
                                </v-select>
                            </v-card> 
                        </v-list-item>
                    </v-list>
                </div>                                     
            </v-card>
        </v-row>

        <v-row class="mr-0">
            <v-card
                flat                
                class="px-3 mt-4" 
                :width="width"               
            >
                <v-row 
                    class=""
                >
                    <v-col class="py-0 pr-0">
                        <v-textarea                                       
                            label="Form Teacher's Report"  
                            v-model="studentRecord.comments"                          
                            persistent-hint
                            dense
                            rows="5"
                            counter                                            
                            class="text-caption"
                            no-resize
                            maxlength="255"
                            :readonly="disabledDeanComment"
                            :filled="disabledDeanComment"
                            @blur="updateRecord"
                            outlined
                            :disabled="disabled"
                        >                        
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-card>
                   
            <v-container fluid class="py-0">

            <v-row>
                <v-col class="pt-0 pr-0">
                    <v-card
                        flat                
                        :width="width"
                                      
                    >
                        <div class="text-center text-subtitle-2 font-weight-bold primary-text">Moral Education</div>
                        <div class="d-flex justify-space-between moral-education">
                            <div class="d-flex flex-column">
                                <span class="text-caption">Grade</span>
                                <v-select
                                    v-model="studentRecord.mmark"
                                    outlined
                                    small-chips
                                    deletable-chips
                                    :items="grades"
                                    item-text="grade"
                                    item-value="grade" 
                                    hide-details
                                    class="mr-2"
                                    @blur="updateRecord"
                                    :disabled="disabled"
                                >
                                    <template v-slot:item="{ item }">
                                        {{ item.grade }} {{ item.scale }}    
                                    </template>
                                </v-select>
                            </div>
                            <div
                                class="d-flex flex-column"
                            >
                                <span class="text-caption">Application</span>
                                <v-select
                                    v-model="studentRecord.mapp"
                                    outlined
                                    small-chips
                                    deletable-chips
                                    :items="grades2"
                                    item-text="grade"
                                    item-value="grade" 
                                    hide-details
                                    class="mr-2"
                                    @blur="updateRecord"
                                    :disabled="disabled"
                                ></v-select>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="text-caption">Conduct</span>
                                <v-select
                                    v-model="studentRecord.mcon"
                                    outlined
                                    small-chips
                                    deletable-chips
                                    :items="grades2"
                                    item-text="grade"
                                    item-value="grade" 
                                    hide-details
                                    class="mr-2"
                                    @blur="updateRecord"
                                    :disabled="disabled"
                                ></v-select>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="text-caption">Comment</span>
                                <v-select
                                    v-model="studentRecord.mcomm"
                                    outlined
                                    small-chips
                                    deletable-chips
                                    :items="comments"
                                    item-text="id"
                                    item-value="id" 
                                    hide-details
                                    @blur="updateRecord"
                                    :disabled="disabled"
                                >
                                    <template v-slot:item="{ item }">
                                        {{ item.id }} {{ item.comment }}    
                                    </template> 
                                </v-select>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            </v-container>
            
        </v-row>

        <!-- <v-row
            class="mt-0 mr-0"
        >
            <v-col class="pt-0 pr-0">
                <v-card
                    flat
                    :width="width"
                    class="d-flex"
                >
                    <v-btn                
                        color="primary"
                        block
                        small
                        @click="nextClass"
                    >
                        Next Class
                    </v-btn>
                </v-card> 
            </v-col>   
        </v-row> -->

        <v-row
            class="my-2 mr-0"
        >
            <v-col class="pt-0 pr-0">
                <v-card
                    flat
                    :width="width"
                    class="d-flex justify-space-between "
                >
                    <v-btn 
                        class="text-caption pa-2  white--text"
                        width="15"
                        height="30"                
                        color="primary"
                        @click="previousRecord"
                        :disabled="!pagination.prev_page"                
                    >
                        <div class="d-flex justify-center align-center pr-2"> 
                            <v-icon class="">mdi-chevron-left</v-icon>
                            <span>PREV</span>
                        </div>                                         
                    </v-btn>
                    
                    <v-btn 
                        class="text-caption pa-2"
                        width="20"
                        height="30"
                        outlined
                        disabled                
                        text                
                    >
                        <span class="blue--text">{{pagination.current_page}} of {{ pagination.last_page}}</span>                                                        
                    </v-btn>
                    
                    <v-btn 
                        class="text-caption pa-2  white--text"
                        width="20"
                        height="30"
                        dark
                        color="primary"
                        @click="nextRecord"
                        :disabled="!pagination.next_page"
                    >
                        <div class="d-flex justify-center align-center pl-2">
                            <span>NEXT</span>
                            <v-icon>mdi-chevron-right</v-icon>
                        </div>                                         
                    </v-btn>
                </v-card>    
            </v-col>
        </v-row>

       

    </v-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    created(){
        this.initialize();
    },
    computed: {
        ...mapGetters({
            studentRecord: 'termReports/getSelectedStudentRecord',            
            academicYear: 'termReports/getAcademicYear',
            currentTerm: 'termReports/getCurrentTerm',
            primaryColor: 'termReports/getPrimaryColor',
            colorDarken: 'termReports/getColorDarken',
            formTeacherClass: 'termReports/getFormTeacherClass',
            codedComments: 'termReports/getCodedComments',
            table1Records: 'termReports/getTable1Records',
            pagination: 'termReports/getPagination',
            formClasses: 'termReports/getFormClassesList',
            admin: 'auth/getAdmin',
            deanFormClasses: 'termReports/getDeanFormClasses',
        }),

        studentName () {
            return this.studentRecord.first_name + ' ' + this.studentRecord.last_name;
        },

        classId () {
            return this.studentRecord.class_id;
        },

        recordSummary () {
            return [
                {title: 'Student\'s ID', model: 'student_id', select: false, disabled: true, section: 1},
                {title: 'Possible Attendances', model: 'possible_attendance', select: false, disabled: true, section: 1},
                {title: 'Attendances Lost', model: 'times_absent', select: false, disabled: false, section: 1},
                {title: 'Number of Times Late', model: 'times_late', select: false, disabled: false, section: 1},
                {title: 'Application', model: 'app', select: true, disabled: false, section: 1},
                {title: 'Conduct', model: 'con', select: true, disabled: false, section: 1},
            ]
        },

        termName () {
            let termName = '';
            if(this.currentTerm == 1) termName =  '1';
            if(this.currentTerm == 2) termName = '2';
            if(this.currentTerm == 3) termName = '3';
            return termName
        },

        extraCurricularRows () {
            return this.extraCurricular.filter(value => value.sectionRow);
        },       
        
        
    },
    watch: {
        studentRecord: {
            handler () {                
                this.setDisabledFields();
            }
        },

    },
    data: () => ({
        academicPeriod: [
            { title: 'Year', value: '' },
            { title: 'Term', value: '' },
        ],
        grades: [            
            {grade: 'A', scale: '| 75 - 100'},
            {grade: 'B', scale: '| 60 - 74'},
            {grade: 'C', scale: '| 45 - 59'},
            {grade: 'D', scale: '| 35 - 44'},
            {grade: 'E', scale: '| 15 - 34'},
            {grade: 'F', scale: '| 0 - 14'},
            {grade: 'Abs', scale: '| Abs'},
                     
        ],
        grades2: [
            { grade: '10', description: 'Excellent'},
            { grade: '9', description: 'Very Good'},
            { grade: '8', description: 'Good'},
            { grade: '7', description: 'Fair'},
            { grade: '6', description: 'Poor'},
            { grade: '5', description: 'Unsatisfactory'},
        ],       
        options: {
            itemsPerPage: -1,
        },  
        codedComment: { id: null, comment: null },  
        disabled: false,
        expand: false,
        overlay: false,
        search: '',
        width: '330', 
        disabledDeanComment: false,
        comments: [],
    }),
    methods: {
        ...mapActions({ 
            postTable1Record: 'termReports/postTable1Record',
            getTable2Records: 'termReports/getTable2Records', 
            setErrorResponse: 'termReports/setErrorResponse',
            getCodedComments: 'termReports/getCodedComments',            
        }),        
        ...mapMutations({         
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setPagination: 'termReports/setPagination',           
            setLoading: 'termReports/setEditViewTermReportsLoading',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            setExpand: 'termReports/setEditViewTermReportsExpand',
        }),

        async initialize(){ 
            console.log('initializing...')           
            this.academicPeriod[0].value = this.academicYear;
            this.academicPeriod[1].value = this.termName;  
            try {
                const { data } = await this.getCodedComments();
                this.setComments(data);
            } catch (error) {
                if(error.resonse) console.log(error.response);
                else console.log(error);
            }          
            //console.log(this.codedComments);   
        },

        setComments(data){ 
            data.forEach(record =>{
                this.comments.push({ id: record.id, comment: record.detail });
            });           
            
        },


        async updateRecord(){
            console.log('updating...');
            //console.log(this.studentRecord);
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            //this.studentRecord.rel_comment = this.codedComment.id;            
            //console.log(this.studentRecord);
            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
            } catch (error) {
                console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }
            
        },


        async recordNavigation(pagination){
            let response = null;
            this.setOverlay(true);
            this.setLoading(true);
            
            this.makePagination(pagination);
            this.setSelectedStudentRecord(this.table1Records[--pagination]);
            try {
                response = await this.getTable2Records();
                this.setTable2Records(response.data.table2_records);
                this.setStudentSubjects(response.data.student_subjects);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }            
            this.setOverlay(false);
            this.setLoading(false);           
        },

        makePagination(data){
            let prev_page = data;
            let current_page = data;
            let next_page = (current_page === this.pagination.last_page) ? null : ++data;
            prev_page = (current_page === 1) ? null : --prev_page;
            
            let pagination = {
                current_page: current_page,
                last_page: this.pagination.last_page,
                next_page: next_page,
                prev_page: prev_page,
            };
            this.setPagination(pagination);
        },

        async previousRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.prev_page);
            // console.log('previous');
        },

        nextRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.next_page);
            // console.log('next');
        },

        cardWidth (item, index ){
            if(index == 1) return '100px';
            if(item.type == 'select') return '100px'
            return '65px'
        },

        setDisabledFields () {
            this.disabled = false;
            this.recordSummary.forEach(element => {
                if(element.model != 'student_id')
                element.disabled = false;
            })
            if(this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && !this.admin){
                console.log('Not the form Teacher');
                this.disabled = true;
                this.recordSummary.forEach(element => {
                    element.disabled = true;
                })                    
            }
           
            
            
        },

        nextClass () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        checkNumber (model) {
            const validNumber = /^[0-9]+$/.test(this.studentRecord[model]);
            console.log(validNumber)
            if(!validNumber){
                this.studentRecord[model] = null;
            }
        }
        
    },

   
}
</script>

<style scoped>
    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    ::v-deep .v-list--dense .v-list-item{
        min-height: 32px;
    }

    .v-btn__content{
        font-size: 0.9em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
        padding-left: 0 !important;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    ::v-deep .v-select__selection--comma{
        margin: 0 4px 4px 0;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-chip.v-size--default{
        height: 20px;
        font-size: 11px;
    }

    /* ::v-deep .times_late .v-chip.v-size--default{
        margin-top: 0;
    } */

    ::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{
            min-height: 8px;
        }

    ::v-deep .v-select.v-select--chips .v-select__selections{
        min-height: 8px;
    }

    ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot{
        padding: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-select__selections .v-chip{
        font-size: 10px;
        height: 20px;
    }

    ::v-deep .moral-education .v-input{
        width: 75px;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-chip--select .v-chip__content .v-icon{
        margin-left: 2px;
    }

    ::v-deep .v-textarea textarea{
        line-height: 1.2rem;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 2px;
    } */

    /* ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }     */
</style>